var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLockIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64383 9.5047H3.8285L3.82741 6.26974C3.82741 0.753251 10.5526 -2.12289 14.5188 1.84333C15.6546 2.97918 16.3587 4.54575 16.3587 6.26974V9.5047C17.5369 9.5047 18.4959 9.36693 19.4104 10.2804C19.8888 10.7588 20.1861 11.4195 20.1861 12.1475L20.1872 22.3562C20.1872 23.0841 19.8899 23.7448 19.4115 24.2232L19.4093 24.2211C18.9287 24.7006 18.268 24.9989 17.5433 24.9989L2.64382 25C1.18792 25 0.00108487 23.8121 0.00108487 22.3573L0 12.1475C0 10.6927 1.18793 9.5047 2.64383 9.5047ZM14.6936 6.26974C14.6936 2.23298 9.76613 0.103371 6.84667 3.02284C6.0124 3.8571 5.49491 5.00706 5.49491 6.26974V9.5047H14.6935L14.6936 6.26974Z",
    fill: "#FF0000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LockIcon.28ccfc32.svg";
export { ForwardRef as ReactComponent };